var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "53e292d7-f3e3-42c9-92da-58060eaf26f6"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d94f6bff-be6c-4e8e-b9a8-a3a21a5cc510"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.76 0 0 6.76 585.99 611.49)",
    id: "33562b16-98b0-4b87-9d36-0bb96cedcb81"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.08 0 0 3.08 726.1 817.62)",
    id: "c94dbd10-a80e-47c8-a8c4-d416e4e76d84"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.08 0 0 3.08 358.73 540)",
    id: "c94dbd10-a80e-47c8-a8c4-d416e4e76d84"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.08 0 0 3.08 445.05 809.12)",
    id: "c94dbd10-a80e-47c8-a8c4-d416e4e76d84"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.08 0 0 3.08 807.15 540)",
    id: "c94dbd10-a80e-47c8-a8c4-d416e4e76d84"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.08 0 0 3.08 575.08 370.37)",
    id: "c94dbd10-a80e-47c8-a8c4-d416e4e76d84"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.97 0 0 12.97 570.47 570.47)",
    id: "b8bb359e-1c65-4205-a007-0d754bc3d3ef"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -50)",
    d: "M 87.294 41.605 L 61.56099999999999 37.833 L 50.00099999999999 14.532999999999998 L 38.43999999999999 37.833 L 12.70699999999999 41.605 L 31.32299999999999 59.797 L 26.94299999999999 85.467 L 50.001999999999995 73.362 L 73.06 85.467 L 68.739 59.797 L 87.294 41.605 z M 50.001 65.087 L 35.095 72.875 L 37.893 56.325 L 25.909 44.585 L 42.516 42.152 L 50.001 27.064 L 57.482 42.152 L 74.089 44.585 L 62.105 56.325 L 64.905 72.875 L 50.001 65.087 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow-star.9489a3af41e7ffe1f0a0c8272bae6a61.svg";
export { ForwardRef as ReactComponent };